module.exports = __webpack_public_path__ + "img/coin.10491089.png";